import React, { lazy } from "react";

const AccountPage = lazy(() => import("./AccountPage"));

const accountRoute = {
  path: "account",
  element: <AccountPage />,
  root: false,
  permission: "ui_view_account",
};

export default accountRoute;
